export const SETTINGS_TYPE_ID = {
  ON: 1,
  OFF: 2,
  DEPENDENT_ON_ADVISER_ORG: 3,
};
